var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['plane-list-wrapper']},_vm._l((_vm.items),function(item){return _c('Plane',{key:item},[_c('PicCircle',{attrs:{"helper":"initials","label":item,"labeled":""}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }